export const PAGE_COUNT = {
    FIRST: 1,
    FIFTH: 5,
} as const;

export const PAGE_NUMBER = {
    ONE: 1,
} as const;